import cn from 'classnames';
import { ButtonWithIcon } from '@ui/button';
import { IWarehouseBagTemplateProps } from '..';
import styles from './styles.module.sass';
import { warehouseModel } from '@/entities/warehouse';
import { useStore } from 'effector-react';
import { SLEEVE_WEIGHT_TONS_PER_METER } from '@/shared/constants/sleeve.constants';
import { getClassInfo } from '../healpers/getClassInfo';

export function WarehouseBagSleeveTemplate(props: IWarehouseBagTemplateProps) {
  const {
    className,
    image,
    cultureName,
    sleeveId = '',
    attention = false,
    borderColor = 'transparent',
    backgroundColor = 'transparent',
    params = [],
    actions = null,
    mixed = false,
    weight = 0,
    resevedWeight,
    values,
    ...rest
  } = props;
  const rootClass = cn(className, styles.bag);
  const selectedWarehouse = useStore(warehouseModel.$warehouseInfo);
  const sleeveMaxWeight = selectedWarehouse?.bagsSize
    ? selectedWarehouse?.bagsSize * SLEEVE_WEIGHT_TONS_PER_METER.WHEAT
    : null;
  let sleeveFillingPercent = sleeveMaxWeight
    ? Math.round((weight / sleeveMaxWeight) * 100)
    : 100;
  sleeveFillingPercent = sleeveFillingPercent > 100 ? 100 : sleeveFillingPercent;

  return (
    <div className={rootClass} style={{ borderColor, position: 'relative' }} {...rest}>
      <div
        className={styles.fillingPercentage}
        style={{ width: `${sleeveFillingPercent}%`, backgroundColor }}
      ></div>
      {mixed ? <div className={styles.addedToMix}>добавлено в бункер</div> : ''}
      {resevedWeight ? (
        <div className={styles.addedToOffer}>участвует в сделке</div>
      ) : (
        ''
      )}

      <div className={styles.data}>
        <div className={styles.img}>{image}</div>
        <div className={styles.header}>
          <span className={styles.title}>
            {cultureName} {getClassInfo(values)}
          </span>
          <span className={styles.sleeveId}>{sleeveId}</span>
          {attention && (
            <ButtonWithIcon icon="Attention" className={styles.attention} />
          )}
        </div>
        <div className={styles.params}>{params}</div>
      </div>
      <div className={styles.actions}>{actions}</div>
    </div>
  );
}
